import {useSubscribeToNotificationsQuery} from '@dms/api/appsync';
import {useListSentToastNotificationsQuery} from '@dms/api/core';

import {isDefinedNonZeroValue} from 'shared/web';

export function useNotifications(pageSize: number) {
  const {data, refetch, isLoading, isFetching, isError} = useListSentToastNotificationsQuery(
    {
      limit: pageSize,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useSubscribeToNotificationsQuery((notification) => {
    if (notification.variant === 'toast') {
      refetch();
    }
  });

  const unreadNotificationsCount = data?.notifications?.filter(
    (notification) => !notification.isRead
  ).length;
  const hasUnreadNotifications = isDefinedNonZeroValue(unreadNotificationsCount);

  return {
    data,
    isLoading,
    isFetching,
    isError,
    hasUnreadNotifications,
    unreadNotificationsCount,
  };
}
